module.exports = __webpack_public_path__ + "static/media/FlyerLTStd-BlackCondensed.062f58d5.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/FlyerLTStd-BlackCondensed.otf
// module id = 173
// module chunks = 0